import { supabase } from './supabaseClient.js';

export const getContratantesColectivos = async () => {
  const { data, error } = await supabase
    .from('contratantes_colectivos')
    .select('*')
    .order('nombre_razon_social', { ascending: true });
  if (error) throw error;
  return data || [];
};

export const getContratanteColectivoById = async (id) => {
  const { data, error } = await supabase
    .from('contratantes_colectivos')
    .select('*')
    .eq('id', id)
    .single();
  if (error) throw error;
  return data;
};

export const createContratanteColectivo = async (payload) => {
  const { data, error } = await supabase
    .from('contratantes_colectivos')
    .insert([payload])
    .select()
    .single();
  if (error) throw error;
  return data;
};

export const updateContratanteColectivo = async (id, payload) => {
  const { data, error } = await supabase
    .from('contratantes_colectivos')
    .update(payload)
    .eq('id', id)
    .select()
    .single();
  if (error) throw error;
  return data;
};